import React from 'react';
import StripePanelPage from './stripe-panel-page';

const Disputes = () => (
  <StripePanelPage
    component="disputes"
    title="Disputes"
    description="Chargebacks on this account, and the evidence Stripe needs from you."
    column="full"
  />
);

export default Disputes;
